import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';

export const ModalBox = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '760px',
  maxHeight: '88vh',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#fff',
  borderRadius: '12px',
  outline: 'none',
  overflow: 'hidden',
});

export const ModalHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '56px',
  flexShrink: 0,
  padding: '0 24px',
  backgroundColor: '#3d3d3d',
});

export const ModalTitle = styled(Typography)({
  fontSize: '18px',
  fontWeight: 600,
  color: '#fff',
});

export const ModalBody = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  padding: '24px',
  overflowY: 'auto',
});

export const SectionTitle = styled(Typography)({
  fontSize: '15px',
  fontWeight: 700,
  color: '#262626',
});

export const StepList = styled('ol')({
  margin: 0,
  paddingLeft: '20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  '& li': {
    fontSize: '14px',
    lineHeight: 1.6,
    color: '#404040',
  },
});

export const GuideImage = styled('img')({
  width: '100%',
  borderRadius: '8px',
  border: '1px solid #e5e5e5',
});

// ============================================
// 제출서류 안내 문구 (이미지 하단)
// ============================================
export const NoticeBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '14px 16px',
  backgroundColor: '#fffdf5',
  border: '1px solid #f0e3b8',
  borderRadius: '8px',
});

export const NoticeTitle = styled(Typography)({
  fontSize: '14px',
  fontWeight: 700,
  color: '#262626',
});

export const NoticeText = styled(Typography)({
  fontSize: '14px',
  lineHeight: 1.6,
  color: '#404040',
  '& strong': {
    fontWeight: 700,
    color: '#262626',
  },
});

export const NoticeWarn = styled(Typography)({
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: 1.6,
  color: '#dc2626',
});

// ============================================
// 문의 전화 (모달 최하단)
// ============================================
export const ContactBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const ContactLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#262626',
});

export const ContactValue = styled(Typography)({
  fontSize: '15px',
  fontWeight: 700,
  color: '#0f7f85',
});

export const EmailBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '14px 16px',
  backgroundColor: '#f5fafa',
  border: '1px solid #cfeaec',
  borderRadius: '8px',
});

export const EmailLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#262626',
});

export const EmailValue = styled(Typography)({
  fontSize: '15px',
  fontWeight: 700,
  color: '#0f7f85',
});

export const ModalFooter = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  flexShrink: 0,
  padding: '16px 24px 24px',
  borderTop: '1px solid #f0f0f0',
});

export const DownloadButton = styled(Button)({
  height: '44px',
  minWidth: '180px',
  backgroundColor: '#0f7f85',
  borderRadius: '8px',
  fontSize: '15px',
  fontWeight: 600,
  color: '#fff',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#0c6b70',
  },
});
